module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./SelectMallHomeView.js"));
	}, "SelectMallHomeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SelectMallHomeView!./src/pages/Shop/Member/Personal/SelectMall/SelectMallHome/SelectMallHomeView.js
// module id = 1020
// module chunks = 431